import { HttpMethod } from "./HttpService";

const generateUrl = (resourcePath: string) => {
    const API_URL_PATH = "/voicegain/platform/master";
    const SERVER_URL = "https://raw.githubusercontent.com";
    return new URL(`${API_URL_PATH}${resourcePath}`, SERVER_URL);
};

abstract class VoiceGainGitHubResourcesApi {
    public static getPrivacyPolicy = (): Promise<Response> => {
        const method = HttpMethod.Get;
        const url = generateUrl("/PRIVACY.md");
        const requestInfo: RequestInfo = url.toString();
        const requestInit: RequestInit = { method };
        return fetch(requestInfo, requestInit);
    };

    public static getTermsOfService = (): Promise<Response> => {
        const method = HttpMethod.Get;
        const url = generateUrl("/TERMS-OF-SERVICE.md");
        const requestInfo: RequestInfo = url.toString();
        const requestInit: RequestInit = { method };
        return fetch(requestInfo, requestInit);
    };
}

export default VoiceGainGitHubResourcesApi;
